"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/OnboardingWelcomeHeroPanel/OnboardingWelcomeHeroPanel";

import { cn } from "utils";
import { NextImage } from "@/src/components/NextImage";
import {
  WELCOME_ASSETS,
  WELCOME_HERO_INSET_PX,
  WELCOME_HERO_PANEL_MAX_WIDTH_PX,
} from "@/src/components/OnboardingWelcome/welcomeLayoutTokens";

const I18n = I18nUtil.createScoped(Translations);

interface OnboardingWelcomeHeroPanelProps {
  className?: string;
}

/** Web 右侧 Hero（Figma `91154:55198` / `91154:55200`） */
export const OnboardingWelcomeHeroPanel: React.FC<
  OnboardingWelcomeHeroPanelProps
> = ({ className }) => {
  return (
    <aside
      className={cn(
        "relative hidden min-h-0 w-[40%] max-w-[615px] shrink-0 self-stretch p-3 md:flex md:flex-col",
        className,
      )}
      style={{
        maxWidth: WELCOME_HERO_PANEL_MAX_WIDTH_PX,
        padding: WELCOME_HERO_INSET_PX,
      }}
      data-testid="onboarding-welcome-hero-panel"
      data-figma-node-id="91154:55198"
    >
      <div
        className="relative min-h-0 flex-1 overflow-hidden rounded-5 bg-background_white_overlay100"
        data-figma-node-id="91154:55199"
      >
        <NextImage
          src={WELCOME_ASSETS.webHero}
          alt=""
          width={WELCOME_HERO_PANEL_MAX_WIDTH_PX}
          height={958}
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <p
          className="absolute left-1/2 top-1/2 w-[min(415px,85%)] -translate-x-1/2 -translate-y-1/2 text-center headline_regular_l text-content_aura_lv3_primary"
          data-testid="onboarding-welcome-hero-tagline"
          data-figma-node-id="91154:55200"
        >
          {I18n.t("The money person you've been doing without.")}
        </p>
      </div>
    </aside>
  );
};
